import initSubjectLinePicker from '../../utils/subject-line-picker';

(function(){
    'use strict';

    angular.module('dataHandlingActionSendEmail', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble', 'ngSanitize'])
        .controller('actionSendEmailCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$stateParams', 'Session',  actionSendEmailCtrl]);

    function actionSendEmailCtrl($scope, $rootScope, $timeout, canvasService, helpers, $stateParams, Session){
        $scope.displaySendEmailActionOptions = false;
        $scope.displayList = false;
        $scope.selectedView = false;
        $scope.advancedOptionsBtn = false;
        $scope.advancedOptionsTitle = true;
        $scope.emailOptions = false;
        $scope.wrapOptions = false;
        $scope.validating = false;
        var cEid;

        // When it’s blank, we insert the email title (replace spaces with underlines)
        function initGoogleCampaign () {
            if (!$scope.connections.data.googleAnalyticsAllUrl) {
                $scope.connections.emailData.GoogleAnalyticsCampaign = '';
            } else {
                $scope.connections.emailData.GoogleAnalyticsCampaign = $scope.connections.emailData.EmailName.replace(/ /g, '_');
            }
        };

        $rootScope.$on('displayActionSendEmailModal', function(evt, conn, displayList, selectedView, showTip) {
            $scope.displayList = displayList;
            $scope.selectedView = selectedView;
            if(!$scope.displayList && !$scope.selectedView) $scope.displayList = true;
            $scope.advancedOptionsBtn = false;
            $scope.advancedOptionsTitle = true;
            $scope.emailOptions = false;
            $scope.wrapOptions = false;
            $scope.showTip = showTip;
            $scope.displaySendEmailActionOptions = true;
            $scope.validating = false;
            $scope.connections = angular.copy(conn);
            $scope.displayEmojiModal = false;

            initSubjectLinePicker(`subject-line-picker-container-${$scope.connections.id}`, canvasService, $rootScope.translate, (syncVal) => {
                if($scope.connections && $scope.connections.emailData) {
                    $scope.connections.emailData.Subject = syncVal;
                    $('#delay-modal .modal-body').scrollTop(0);
                }
            });

            if (!$rootScope.userEmailAddress) {
                canvasService
                    .getUserEmailAddress()
                    .success(function (data) {
                        $rootScope.userEmailAddress = data.Results || [];
                        $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                            return obj.Email;
                        });
                    });
            } else {
                $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                    return obj.Email;
                });
            }

            $scope.mergeTags = helpers.getMergeTags();

            if(!$scope.mergeTags.length) {
                $scope.showTagDefault = true;
                $scope.connections.emailData.ToListId = "";
            }
            else if($scope.connections.emailData && !$scope.connections.emailData.ToListId) {
                $scope.connections.emailData.ToListId = $scope.mergeTags[0].id;
            }
            else {
                $scope.connections.emailData.ToListId = $scope.connections.emailData.ToListId + '';
            }

            cEid = (conn && conn.data) ? conn.data.emailId : '';

            const lang = Session.getCookie('L');
            $scope.faqHelpLink = {
                english: 'https://kb.benchmarkemail.com/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                spanish: 'https://kb.benchmarkemail.com/es/puedo-agregar-seguimiento-de-google-analytics-a-mis-campanas-de-correo-electronico/',
                chineset: 'https://kb.benchmarkemail.com/cn/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                chinese: 'https://kb.benchmarkemail.com/tw/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                japanese: 'https://kb.benchmarkemail.com/jp/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                italian: 'https://kb.benchmarkemail.com/it/posso-aggiungere-google-analytics-alla-mia-campagna-email/',
                french: 'https://kb.benchmarkemail.com/fr/comment-ajouter-le-tracking-de-google-analytics-a-mes-campagnes-d-email/',
                brazil: 'https://kb.benchmarkemail.com/br/posso-adicionar-o-monitoramento-do-google-analytics-nas-minhas-campanhas-de-email/',
                german: 'https://kb.benchmarkemail.com/de/kann-ich-google-analytics-tracking-in-meine-e-mail-kampagnen-einfuegen/'
            }[lang || 'english'];
        });

        $rootScope.$on('hideActionSendEmailModal', function() {
            $scope.displaySendEmailActionOptions = false;
            $scope.validating = false;
        });

        $rootScope.$on('displayActionSendEmailModalError', function(evt, errors) {
            $scope.validating = false;
            angular.extend($scope, errors);
        });

        $scope.parseDescription = function (desc) {

            if (desc) {
                if ( desc.length > 15) {
                    desc = desc.slice(0, 15) + '...';
                    //Desc < 15
                }  else if (desc.length < 15) {
                    desc = desc;
                }
            } else {
                return $scope.translate('commons.enterDetails');
            }

            return desc;
        };

        $scope.showDetails = function (evt) {
            $scope.connections.data.emailStatus = 'updateEmail';
            $scope.displayList = true;
            $scope.modalWindow = false;
            $scope.selectedView = false;
            $scope.editorSubMenu = false;

            if ($scope.connections.emailData.Reuse) {
                // We create a clone in case that the user does not change anything and save the connection with the clone
                $scope.cloneConn = angular.copy($scope.connections);
            }
        };

        $scope.previewEmail = function () {
            var emailPreview = $scope.connections.data.emailId;
            $scope.displaySendEmailActionOptions = false;
            $rootScope.$emit('previewEmail', $scope.connections, false, $scope.connections.isDummy);
            $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");
            if($scope.connections.isDummy) {
                emailPreview = cEid;
            }
            canvasService.getPreview(emailPreview)
                .then(function({data}) {
                    if (data.Response.ID) {
                        var obj = data.Response;
                        var content = obj.TemplateContent;
                        if (content.indexOf("<!-- /Footer Path -->") != -1) {
                            content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                        }
                        $("#dvPreviewContent").html("");
                        var iframe = document.createElement('iframe');
                        $(iframe).attr("id", "ifrPreviewContent");
                        $("div#dvPreviewContent").append(iframe);
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(content);
                        iframe.contentWindow.document.close();
                    } else {
                        alert("Could not load Preview");
                    }
                });
        };

        $rootScope.$on('redirectToEditor', function (evt, type, fromDetails, designLink) {
            var _onError = function (err) {
                //Error msg from backend when failing
                if(helpers.getJourneyFirstList() == '11111111') {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.613'));
                } else {
                    $rootScope.$emit('errorMsg', err.Message);
                }

                //Close loader
                $rootScope.$emit('jbLoader', false);

                //When fail we open the list and show another error mesg
                $scope.displayList = true;
                $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);
            };

            var _next = function () {
                var jbTitle = $rootScope.currentJBTitle || 'Journey Name';
                $scope.connections.data.emailStatus = 'fromEditor';
                //If design link has been clicked we change the email status
                if (designLink) {
                    $scope.connections.data.emailStatus = 'updateExisting';
                }

                if ($stateParams.canvasId) {
                    $scope.saveData();
                    $timeout(() => {
                        // when the canvas exists already
                        canvasService
                            .updateJourney({
                                JourneyTitle: jbTitle,
                                JourneyConfiguration: JSON.stringify($rootScope.connections)
                            }, $stateParams.canvasId, $rootScope.connections.length)
                            .success(function (res) {
                                canvasService.redirectToEditor($scope.connections.emailData.Version, $scope.connections.data.emailId, res.JourneyId);
                            })
                            .error(_onError);
                    }, 300);
                }
            };

            if (type) {
                $rootScope.$emit('jbLoader', true);
                if (fromDetails) {
                    _next();
                } else if($scope.connections.data.emailStatus === 'createNew'){
                    $scope.connections.emailData.Version = canvasService.getVersionByType(type);

                    // Dummy email bullet proof
                    if($scope.connections.emailData.ToListId === '11111111'){
                        $scope.connections.emailData.ToListId = 0;
                    }

                    var payload = angular.copy($scope.connections.emailData);

                    canvasService
                        .createEmail(payload)
                        .success(function (id) {
                            angular.merge($scope.connections.emailData, payload);
                            $scope.connections.data.emailId = id;
                            canvasService.generateThumbs(id).then(() => {});
                            _next();
                        })
                        .error(_onError);
                }
            }
        });

        // when the design button is clicked
        $scope.sendToEditor = function () {
            $scope.$emit('redirectToEditor', $scope.connections.emailData.Version, true, true);
        };

        $scope.selectedCancel = function() {
            $scope.displaySendEmailActionOptions = false;
            if($scope.connections) {
                var conn = helpers.getStorageConnectionById($scope.connections.id);
                if(conn) {
                    $scope.connections.data = conn.data;
                    $scope.connections.emailData = conn.emailData;
                    $scope.selectedView = false;
                    $scope.updateConnections();
                }
            }

            if ($scope.connections.emailData.Reuse) {
                $scope.connections.emailData.Reuse =  false;
                $scope.saveData();
            }

            $rootScope.$emit('cleanSendEmailErrors');
        };

        //Cancel Button
        $scope.cancel = function () {
            $scope.displaySendEmailActionOptions = false;
            if($scope.connections) {
                var conn = helpers.getStorageConnectionById($scope.connections.id);
                if(conn) {
                    $scope.connections.data = conn.data;
                    $scope.connections.emailData = conn.emailData;
                    $scope.selectedView = false;
                    $scope.updateConnections();
                }
            }

            $rootScope.$broadcast('cleanSendEmailErrors');

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node && !$scope.connections.emailData.Reuse) {
                // Execute listener when user cancel the send email
                $rootScope.$broadcast('deleteSendEmailNode' + $scope.connections.id);
            } else {
                if (!angular.equals($scope.connections, $scope.cloneConn)) {
                    $scope.connections = $scope.cloneConn;
                }
                $scope.save();
            }
        };

        $scope.switcher = function (type) {
            switch (type) {
                case 'permisionReminder':
                    $scope.connections.data.permisionReminder = !$scope.connections.data.permisionReminder;
                    if ($scope.connections.data.permisionReminder) {
                        $scope.connections.emailData.PermissionReminderMessage = $rootScope.emptyEmail.PermissionReminderMessage;
                    }
                    else {
                        $scope.connections.emailData.PermissionReminderMessage = '';
                    }
                    break;
                case 'webPageVersion':
                    $scope.connections.emailData.WebpageVersion = !$scope.connections.emailData.WebpageVersion;
                    break;
                case 'previewText':
                    $scope.connections.data.pageTextTextarea = !$scope.connections.data.pageTextTextarea;
                    break;
                case 'googleAnalyticsAllUrl':
                    $scope.connections.data.googleAnalyticsAllUrl = !$scope.connections.data.googleAnalyticsAllUrl;
                    initGoogleCampaign();
                    break;
            }
        };

        $scope.saveData = function() {
            Intercom('trackEvent', 'AP - SendEmail');
            $scope.displaySendEmailActionOptions = false;
            $rootScope.$emit('saveActionSendEmailData' + $scope.connections.id, $scope.connections);
        };

        $scope.save = function() {
            if(!$scope.validating) {
                $scope.validating = true;
                $rootScope.$emit('saveActionSendEmail' + $scope.connections.id, $scope.connections);
            }
        };

        $scope.updateConnections = function() {
            $rootScope.$emit('updateSendEmailConn' + $scope.connections.id, $scope.connections, $scope.selectedView);
        };

        $scope.displayModal = function () {
            $scope.displaySendEmailActionOptions = false;
            $scope.displayList = false;
            $scope.selectedView = false;
            $rootScope.$emit('displayModalSendEmail' + $scope.connections.id);
        };

        $scope.toggleEmojiModal = () => {
            $scope.displayEmojiModal = !$scope.displayEmojiModal;
            $scope.displaySendEmailActionOptions = !$scope.displaySendEmailActionOptions;
        };

        $rootScope.$on('hideEditorModal', function (event, connections) {
            $scope.connections = connections;
            $scope.displaySendEmailActionOptions = true;
            $scope.displayList = true;
        });

        $rootScope.$on('cleanSendEmailErrors', function () {
            $scope.eNameErr = false;
            $scope.sbjErr = false;
            $scope.pgTextError = false;
            $scope.eFromErr = false;
            $scope.eFromReplyErr = false;
            $scope.eFromSubjErr = false;
            $scope.ePermissionReminder = false;
            $scope.analyticsError = false;
        });

        $rootScope.$on('syncEmoji', function (evt, emojiVal) {
            if($scope.connections && $scope.connections.emailData) {
                $scope.connections.emailData.Subject = emojiVal;
            }
        });

        $rootScope.$on('syncEmojiPreviewText', function (evt, emojiVal) {
            if($scope.connections && $scope.connections.emailData) {
                $scope.connections.emailData.InboxPreviewText = emojiVal;
            }
        });
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionSendEmailController.js